import { httpService } from "./httpService";

export const manageSubscription = {
    async getSubscriptionData() {
        try {
            const response = await httpService.getRequest<any>(`billing/subscription`);
            const subscriptionData = response.data;
            return subscriptionData;
        } catch (error) {
            console.error("Error fetching subscription data:", error);
        }
    },
};